module.exports = __webpack_public_path__ + "img/ic_qrcode_wechat.1731953.webp";